import {
    AMPLIFY_GET_CAMPAIGNS,
    AMPLIFY_GET_DONATIONS,
    AMPLIFY_GET_DONATION_GROUPS
} from '../constants/amplify.js';

export const initialState = {
    campaigns: {},
    donations: {},
    donationGroups: {}
};

export function amplifyReducer( state = initialState, action ) {

    switch ( action.type ) {

        case AMPLIFY_GET_CAMPAIGNS:
            return Object.assign({}, state, {
                campaigns: action.campaigns,
                sortedCampaigns: action.sortedCampaigns
            });

        case AMPLIFY_GET_DONATIONS:
            return Object.assign({}, state, {
                donations: action.donations
            });

        case AMPLIFY_GET_DONATION_GROUPS:
            return Object.assign({}, state, {
                donationGroups: action.donationGroups
            });

        default:
            return state;

    }

}



// WEBPACK FOOTER //
// ./src/reducers/amplify.js